<div class="h-[84px] bg-white shadow-[0px_4px_30px_0px_#E3EAF2]">
    <div class="container flex items-center gap-[20px] py-[24px]">
        @if (userService.currentUser()) {
            <button (click)="toggleDrawer.emit()" mat-icon-button type="button">
                <mat-icon>menu</mat-icon>
            </button>
        }

        <button (click)="routeToHome()" class="cursor-pointer" type="button">
            <img alt="tbm" height="48" ngSrc="/assets/images/tbm/ps-tbm-logo.png" width="250" />
        </button>

        @if (userService.currentUser()) {
            <div class="ml-auto">
                <button [matMenuTriggerFor]="userMenu" class="scale-[1.5]" mat-icon-button>
                    <img alt="user" height="42" ngSrc="/assets/icons/user.svg" width="42" />
                </button>
                <mat-menu #userMenu="matMenu" xPosition="before" class="user-menu">
                    <button (click)="logout()" mat-menu-item>
                        <span>Logout</span>
                    </button>
                </mat-menu>
            </div>
        }
    </div>
</div>
